import React from 'react'
import Masthead from '@ta-interaktiv/react-masthead'
import CopyrightNotice from '@ta-interaktiv/react-copyright-notice'
import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
import PolymorphicShareButtons from '@ta-interaktiv/react-share-buttons'
import Tracking from '@ta-interaktiv/react-tracking'
import { TimestampFormatter } from '@ta-interaktiv/react-publication-info'
import Waypoint from 'react-waypoint'
import Cover from '../cover'
import Scrollchor from 'react-scrollchor'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'

import 'styles/App.css'

export default class AppComponent extends React.Component {
  constructor (props) {
    super(props)
    this.trackNavClicks = this.trackNavClicks.bind(this)
    this.trackTopClicks = this.trackTopClicks.bind(this)

    this.state = {
      isMobile: true
    }
  }

  componentDidMount () {
    const isMobile = window.innerWidth < 800
    this.setState({ isMobile })
  }

  trackNavClicks (e) {
    let clickedText = e.currentTarget.firstChild.nodeValue
    /* console.log('target:' + clickedText) */
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'question: ' + clickedText
    })
  }

  trackTopClicks (e) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'toTop: '
    })
  }

  render () {
    return (
      <div className='index'>
        <Masthead articleId='19012715' />
        <header className='ui vertical fitted segment'>
          <Cover title='Das müssen Sie wissen, bevor Sie über die Sozialhilfe abstimmen' />
        </header>
        <main className='ui vertical fitted segment'>
          <div className='ui text container'>
            <p className='ta lead'>
              <br />
              Das Kanton Bern steht vor einer der umstrittensten Abstimmungen
              der letzten Jahren. Wer mitreden will, sollte diese Zahlen und
              Fakten kennen.
            </p>
            <p className='ta author'>
              Von Fabian Christl (Text) und Christian Zellweger (Umsetzung)
            </p>
          </div>
          <Waypoint
            scrollableAncestor={window}
            onEnter={(event) => {
              if (event.previousPosition === 'below') {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'startReading'
                })
              }
            }}
          />
          <div className='ui text container'>
            <p>
              Am 19. Mai befinden die bernischen Stimmberechtigten über die
              Sozialhilfe. Zur Auswahl stehen die Revision des
              Sozialhilfegesetzes (SHG-Revision), der Volksvorschlag «für eine
              wirksame Sozialhilfe» sowie der Status Quo. Antworten auf die
              wichtigsten Fragen sowie Links zu weiterführenden «Bund»-Artikeln
              finden Sie im Folgenden zusammengefasst.
            </p>
            <p>
              Falls Sie eine Übersicht über alle im «Bund» erschienenen Artikel
              zum Thema wünschen, finden Sie diese{' '}
              <a href='https://interaktiv.derbund.ch/ext/2019/sozialhilfe/'>
                <i className='external icon' />
                im entsprechenden Dossier auf unserer Webseite
              </a>
              .
            </p>
            <ul className='nav' id='nav'>
              <Scrollchor to='#question-1'>
                <li className='question-link' onClick={this.trackNavClicks}>
                  1. Was will die Revision des Sozialhilfegesetzes?
                </li>
              </Scrollchor>
              <Scrollchor to='#question-2'>
                <li className='question-link' onClick={this.trackNavClicks}>
                  2. Was will der Volksvorschlag?
                </li>
              </Scrollchor>
              <Scrollchor to='#question-3'>
                <li className='question-link' onClick={this.trackNavClicks}>
                  3. Wer bezieht überhaupt Sozialhilfe?
                </li>
              </Scrollchor>
              <Scrollchor to='#question-4'>
                <li className='question-link' onClick={this.trackNavClicks}>
                  4. Was erhalten Sozialhilfebezüger heute, was erhalten sie in
                  Zukunft?
                </li>
              </Scrollchor>
              <Scrollchor to='#question-5'>
                <li className='question-link' onClick={this.trackNavClicks}>
                  5. Was spricht für die Revision und was dagegen?
                </li>
              </Scrollchor>
              <Scrollchor to='#question-6'>
                <li className='question-link' onClick={this.trackNavClicks}>
                  6. Was spricht für den Volksvorschlag, und was dagegen?
                </li>
              </Scrollchor>
              <Scrollchor to='#question-7'>
                <li className='question-link' onClick={this.trackNavClicks}>
                  7. Wie positionieren sich die Parteien?
                </li>
              </Scrollchor>
              <Scrollchor to='#question-8'>
                <li className='question-link' onClick={this.trackNavClicks}>
                  8. Was ist die Meinung der «Bund»-Redaktion?
                </li>
              </Scrollchor>
            </ul>
            <FeedbackMessage mailTo='bern@derbund.ch' />
          </div>
          <Waypoint
            scrollableAncestor={window}
            onEnter={(event) => {
              if (event.previousPosition === 'below') {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'startContent'
                })
              }
            }}
          />
          <div
            className='ui question container'
            id='question-1'
            style={{ textAlign: 'left' }}
          >
            <h2>
              <span className='title-text'>
                1. Was will die Revision des Sozialhilfegesetzes?
              </span>
              <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>{' '}
                  <i className='chevron up icon' />
                </div>
              </Scrollchor>
            </h2>
          </div>
          <div className='ui text container'>
            <p>
              Die SHG-Revision sieht eine Senkung des Grundbedarfs vor. Dieser
              soll künftig für alle Bezügerinnen und Bezüger 8 Prozent unter den
              Empfehlungen der Schweizerischen Konferenz für Sozialhilfe (Skos)
              liegen. Für junge Erwachsene und vorläufig Aufgenommen sind gar
              Kürzungen um 15-30 Prozent vorgesehen. Mit dem Grundbedarf müssen
              sämtliche Ausgaben für Nahrung, Kleidung, Haushalt, Mobilität,
              Internet, Fernsehen, Handy und Freizeit finanziert werden. Heute
              beträgt er im Kanton Bern für eine Einzelperson 977 Franken,
              künftig sollen es 907 Franken sein.
            </p>
            <p>
              Als Kompensation der Kürzungen sollen im Gegenzug die
              Anreizleistungen erhöht werden. Um wie viel, wird erst nach der
              Abstimmung mittels einer Verordnung definitiv geregelt. Laut der
              Gesundheits- und Fürsorgedirektion (GEF) von Regierungsrat Pierre
              Alain Schnegg (SVP) dürfte die Integrationszulage (IZU) von 100
              Franken auf 200 Franken erhöht werden, in Ausnahmefälle wären
              sogar 300 Franken möglich. Es sollen aber weniger Bezügerinnen und
              Bezüger eine Integrationszulage erhalten als heute.
            </p>
            <p>
              Der Einkommensfreibetrag (EFB) soll zwar nicht erhöht werden,
              künftig soll der maximale EFB aber unbefristet bezogen werden
              können, und nicht nur für die ersten sechs Monate nach
              Arbeitsaufnahme beziehungsweise Eintritt in die Sozialhilfe.
            </p>
            <p>
              Vorgesehen ist weiter, dass ein Teil der durch die Kürzungen
              eingesparten Gelder in Eingliederungsmassnahmen investiert wird.
              Wie viel, hängt vom Spareffekt der Vorlage ab. Dieser wird auf
              8-19 Millionen Franken geschätzt. Laut den jüngsten Informationen
              der GEF, sollen fix 10 Millionen Franken eingespart werden. Falls
              die Einsparungen höher liegen, würde der Rest reinvestiert.
            </p>
            <ul>
              <li>
                Hiess es ursprünglich nicht, dass die Hälfte des eingesparten
                Geldes reinvestiert werden soll? Doch. Folgender Artikel hilft
                weiter:
                <br />
                <a
                  href={
                    this.state.isMobile
                      ? 'https://m.derbund.ch/articles/5cba1ec6ab5c377a41000001'
                      : 'https://www.derbund.ch/16790946'
                  }
                  target='_blank'
                >
                  <i className='external icon' />
                  «Eingliederung: Ob es mehr Geld gibt, ist ungewiss»
                </a>
              </li>
              <li>
                Eingliederungsmassnahme: Was soll das sein? Folgender Artikel
                hilft weiter:{' '}
                <a href='https://webspecial.derbund.ch/longform/sozialhilfe-beschaeftigungsangebote/sozialhilfe-beschaeftigungsangebote/'>
                  <i className='external icon' />
                  Schleifen für den Arbeitsmarkt
                </a>
              </li>
            </ul>
          </div>
          <div
            className='ui question container'
            id='question-2'
            style={{ textAlign: 'left' }}
          >
            <h2>
              <span className='title-text'>
                2. Was will der Volksvorschlag?
              </span>
              <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>{' '}
                  <i className='chevron up icon' />
                </div>
              </Scrollchor>
            </h2>
          </div>
          <div className='ui text container'>
            <p>
              Der Volksvorschlag verlangt, dass der Grundbedarf nach den
              Richtlinien der Schweizerischen Konferenz für Sozialhilfe (Skos)
              ausgerichtet wird. Diese sollen einen schweizweit einheitlichen
              Umgang mit den Bedürftigen ermöglichen. Aktuell richtet der Kanton
              den Grundbedarf nach veralteten Skos-Richtlinien aus, welche die
              Teuerung der letzten Jahre nicht beinhalten. So beträgt der
              Grundbedarf für eine Einzelperson im Kanton Bern 977 Franken,
              während die Skos 986 Franken empfiehlt. Mit dem Volksvorschlag
              würde also der Grundbedarf leicht erhöht.
            </p>
            <p>
              Zudem sieht der Volksvorschlag eine Besserstellung der älteren
              Arbeitslosen vor. Diese sollen statt Sozialhilfe
              Ergänzungsleistungen bekommen. Der Grundbedarf bei den
              Ergänzungsleistungen beträgt 1620 Franken pro Monat. Von der
              Besserstellung sollen aber nur Personen profitieren können, die
              erst im Alter von 55 Jahren oder später ihre Stelle verloren
              haben, schon länger im Kanton Bern wohnhaft sind und während 20
              Jahren Geld in die Arbeitslosenkassen einbezahlt haben.
            </p>
            <p>
              Als dritter Punkt fordert der Volksvorschlag
              Qualifizierungsmassnahmen für die Bedürftigen. Also, dass man den
              Bezügerinnen und Bezügern von Sozialhilfe stärker als heute
              ermöglicht, Ausbildungen zu machen, die ihre Chancen auf eine
              Arbeitsstelle erhöhen.
            </p>
            <p>
              Der Volksvorschlag hätte jährliche Mehrkosten in der Höhe von
              17-28 Millionen Franken zur Folge.
            </p>
            <ul>
              <li>
                Wie SP-Grossrätin Margrit Junker, eine der Architektinnen des
                Volksvorschlag, die Sache sieht:{' '}
                <a
                  href={
                    this.state.isMobile
                      ? 'https://m.derbund.ch/articles/5cb364e2ab5c375744000001'
                      : 'https://www.derbund.ch/20288918'
                  }
                >
                  <i className='external icon' />
                  «Das erzeugt nur Aggression und Wut»
                </a>
              </li>
              <li>
                Wieso sollen ausgerechnet ältere Arbeitslose bessergestellt
                werden? Folgender Artikel hilft weiter:{' '}
                <a href='https://webspecial.derbund.ch/longform/sozialhilfe/alterssozialhilfe/'>
                  <i className='external icon' />
                  «Die Angst vor dem riesigen Loch»
                </a>
              </li>
            </ul>
          </div>
          <div
            className='ui question container'
            id='question-3'
            style={{ textAlign: 'left' }}
          >
            <h2>
              <span className='title-text'>
                3. Wer bezieht überhaupt Sozialhilfe?
              </span>
              <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>{' '}
                  <i className='chevron up icon' />
                </div>
              </Scrollchor>
            </h2>
          </div>
          <div className='ui text container'>
            <p>
              Im Kanton Bern beziehen 42'700 Personen Sozialhilfe. Die Quote
              beträgt 4,2 Prozent - und liegt somit um ein Prozentpunkt höher,
              als im schweizerischen Schnitt.
            </p>
            <p>
              Weitaus das grösste Risiko für Sozialhilfeabhängigkeit besteht für
              Alleinerziehende. Die Quote beträgt dort 30 Prozent – von zehn
              Alleinerziehenden werden im Kanton Bern also drei ganz oder
              teilweise von der Sozialhilfe unterstützt. Bei alleinerziehenden
              Müttern unter 25 Jahren ist die Quote nochmals massiv höher.
              Generell ist die Sozialhilfequote von Familien höher als die von
              kinderlosen Haushalten.
            </p>
            <h4>Das Risiko, von der Sozialhilfe abhängig zu werden</h4>
            <h5>
              Vor allem Alleinerziehende risikieren, Sozialhilfe beziehen zu
              müssen
            </h5>
            <p>
              <img
                src={require('./img/neu/risiko-neu.svg')}
                alt=''
                className='ui fluid image'
              />
            </p>
            <p>
              Auch Ausländer sind in der Sozialhilfe überproportional vertreten.
              Sie machen 43,4 Prozent der Sozialhilfebezügerinnen und -bezüger
              aus, bilden aber nur 16 Prozent der bernischen Gesamtbevölkerung.
              Nicht einberechnet sind Asylsuchende und abgewiesene Asylbewerber.
              Anerkannte Flüchtlinge und vorläufig Aufgenommene erscheinen erst
              nach fünf respektive sieben Jahre in der Statistik – vorher ist
              der Bund für die Finanzierung zuständig.
            </p>
            <h4>Wer im Kanton Bern Sozialhilfe bezieht</h4>
            <h5>Ein Drittel der Sozialhilfebezüger sind jünger als 17 Jahre</h5>
            <p>
              <img
                src={require('./img/neu/sozialhilfebeziehende-neu.svg')}
                alt=''
                className='ui fluid image'
              />
            </p>
            <p>
              Knapp ein Drittel der Sozialhilfebeziehenden sind Kinder und
              Jugendliche. Von den Bezügerinnen und Bezügern im erwerbsfähigen
              Alter (15–64 Jahre) sind 29 Prozent bereits erwerbstätig, aber
              verdienen nicht genug, um ihren gesamten Bedarf zu decken. Weitere
              36 Prozent gelten als temporär erwerbsunfähig. Es handelt sich um
              Kranke, Drogenabhängige, Alkoholiker und Leute, die etwa aufgrund
              Kleinkinder ({'<'}1 Jahr) derzeit keine Erwerbsarbeit aufnehmen
              können.
            </p>
            <p>
              Stark überproportional vertreten sind zudem Personen ohne
              Berufsabschluss. Sie machen knapp die Hälfte der Bezügerinnen und
              Bezüger aus. Diese Gruppe hat es auf dem Arbeitsmarkt besonders
              schwer, weil viele Stellen für Niedrigqualifizierte ins Ausland
              verlagert wurden oder der Digitalisierung zum Opfer fielen.
            </p>
            <ul>
              <li>
                Möchten Sie mehr über die Klienten der Sozialdienste erfahren?
                Folgender Artikel hilft weiter:{' '}
                <a href='https://webspecial.derbund.ch/longform/sozialhilfe/inhalt-sozialhilfe/'>
                  <i className='external icon' />
                  «Es reicht schon heute nicht. Punkt.»
                </a>
              </li>
            </ul>
          </div>
          <div
            className='ui question container'
            id='question-4'
            style={{ textAlign: 'left' }}
          >
            <h2>
              <span className='title-text'>
                4. Was erhalten Sozialhilfebezüger heute, was erhalten sie in
                Zukunft?
              </span>
              <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>{' '}
                  <i className='chevron up icon' />
                </div>
              </Scrollchor>
            </h2>
          </div>
          <div className='ui text container'>
            <p>
              Sozialhilfebezügerinnen und -Bezüger erhalten die
              Gesundheitskosten und die Wohnkosten (bis zu einem kommunal
              festgelegten Betrag) erstattet. Daran ändern weder SHG-Revision
              noch Volksvorschlag etwas. Ebenso werden den Bedürftigen über die
              so genannten situationsbedingten Leistungen gewisse weitere Kosten
              erstattet. Dazu gehören etwa zwingend nötige Zahnbehandlungen.
            </p>
            <p>
              Zudem erhalten sie einen Grundbedarf. Dieser beträgt heute für
              einen Einpersonen-Haushalt 977 Franken, für eine Familie mit zwei
              Kindern 2090 Franken. Der Grundbedarf kann frei eingeteilt werden.
              Folgende Tabelle zeigt, was damit finanziert werden soll und wie
              viel Geld für die verschiedenen Ausgabenposten vorgesehen ist:
            </p>
            <h4>Was ein Einpersonenhaushalt zur Verfügung hat</h4>
            <h5>Nach aktuell gültigem Gesetz</h5>
            <p>
              <img
                src={require('./img/neu/einpersonenhaushalt-neu.svg')}
                alt=''
                className='ui fluid image'
              />
            </p>
            <p>
              Die SHG-Revision sieht eine Kürzung des Grundbedarfs um in der
              Regel 8 Prozent vor. Ein Einpersonen-Haushalt hätte demnach noch
              907 Franken pro Monat, eine vierköpfige Familie noch 1941 Franken.
            </p>
            <p>
              Der Volksvorschlag möchte den Grundbedarf streng nach den
              Skos-Richtlinien ausrichten. Ein Einpersonen-Haushalt erhielte
              demnach 986 Franken, eine vierköpfige Familie 2110 Franken.
            </p>
            <p>
              Die SHG-Revision sieht zudem eine Erhöhung der Anreizleistungen
              vor. So soll etwa der maximale Einkommensfreibetrag von 600
              Franken unbefristet bezogen werden können. Heute sinkt der
              Freibetrag sechs Monate nach Arbeitsaufnahme bzw. Eintritt in die
              Sozialhilfe auf 400 Franken. Die Integrationszulage soll wieder
              auf 200 Franken erhöht werden.
            </p>
            <p>
              Der Volksvorschlag geht nicht explizit auf die Anreizleistungen
              ein. Da er sich aber explizit auf die Skos-Richtlinien bezieht,
              gehen Experten davon aus, dass er auch eine Erhöhung der
              Anreizleistungen im gleichen Umfang wie die SHG-Revision zur Folge
              hätte.
            </p>
            <p>
              Folgende Infografiken zeigen einige Rechenbeispiele, wie sich
              SHG-Revision und Volksvorschlag auswirken würden:
            </p>
            <h4>Was eine vierköpfige Familie zur Verfügung hat</h4>
            <h5>gemäss gültigem Gesetz</h5>
            <p>
              <img
                src={require('./img/neu/familie-mit-zwei-kindern-neu.svg')}
                alt=''
                className='ui fluid image'
              />
            </p>
            <h4>Was Junge und Alleinerziehende zu Verfügung haben</h4>
            <h5>gemäss gültigem Gesetz</h5>
            <p>
              <img
                src={require('./img/neu/junger-mann-alleinerziehende-frau-neu.svg')}
                alt=''
                className='ui fluid image'
              />
            </p>
            <h4>Was Alleinstehende zur Verfügung haben</h4>
            <h5>gemäss gültigem Gesetz</h5>
            <p>
              <img
                src={require('./img/neu/mann-frau-neu.svg')}
                alt=''
                className='ui fluid image'
              />
            </p>
          </div>
          <div
            className='ui question container'
            id='question-5'
            style={{ textAlign: 'left' }}
          >
            <h2>
              <span className='title-text'>
                5. Was spricht für die Revision und was dagegen?
              </span>
              <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>{' '}
                  <i className='chevron up icon' />
                </div>
              </Scrollchor>
            </h2>
          </div>
          <div className='ui text container'>
            <p>
              Die SHG-Revision ist eine Sparvorlage. Durch die Kürzung sollen
              Kanton und Gemeinden je 4-5 Millionen Franken einsparen. Dies weil
              in den letzten 15 Jahren die Sozialhilfe-Kosten gestiegen sind,
              wie folgende Grafik illustriert:
            </p>
            <h4>Kosten und Bezüger in der Sozialhilfe</h4>
            <h5>Trotz konstanter Bezügerzahlen steigen die Kosten.</h5>
            <p>
              <img
                src={require('./img/neu/steigende-kosten-v2-neu.svg')}
                alt=''
                className='ui fluid image'
              />
            </p>
            <p>
              Zudem will die SHG-Revision die Sozialhilfe unattraktiver machen,
              damit sich die Aufnahme einer Erwerbsarbeit für Bezügerinnen und
              Bezüger stärker lohnt. Familien ab 4 Personen, die von der
              Sozialhilfe abhängig sind, haben heute in gewissen Fällen
              gleichviel oder sogar mehr Geld zur Verfügung, als erwerbstätige
              Familien ohne Anspruch auf Sozialhilfe. Das zeigt etwa dieses, von
              der Gesundheits- und Fürsorgedirektion konzipierten Beispiels:
            </p>
            <h4>Wenn sich Arbeit nicht mehr lohnt</h4>
            <h5>Schwelleneffekte in der Sozialhilfe sind möglich.</h5>
            <p>
              <img
                src={require('./img/neu/sozialhilfetabelle-neu.svg')}
                alt=''
                className='ui fluid image'
              />
            </p>
            <p>
              Dank höheren Anreizleistungen kann zudem stärker zwischen den
              verschiedenen Bezügerinnen und Bezügern differenziert werden. Wer
              erwerbstätig ist oder an einem Beschäftigungsprogramm teilnimmt,
              wird künftig stärker belohnt. Das entspricht den
              Gerechtigkeitsvorstellungen der Gesellschaft.
            </p>
            <p>
              Gegen die Revision spricht, dass die Sozialhilfe schon heute knapp
              bemessen ist. In den letzten Jahren wurden die Beiträge schon
              mehrmals gekürzt. Gerade für soziale Aktivitäten bleibt kaum Geld.
              Eigentlich sollte der Grundbedarf dem entsprechen, was die 10
              Prozent einkommensschwächsten Haushalte für die notwendigen Dinge
              ausgeben. Nach dieser Logik ist der Grundbedarf schon heute rund
              100 Franken zu tief bemessen.
            </p>
            <p>
              Fraglich ist zudem, ob es den Bezügerinnen und Bezügern überhaupt
              an Anreiz mangelt. So bekunden Firmen keine Mühe, ihre Stellen für
              Niedrigqualifizierte zu besetzen. Die Arbeitslosigkeit beträgt in
              diesem Sektor bereits über 10 Prozent.
            </p>
            <p>
              Letztlich hilft die Revision auch nicht, das Problem der
              Schwelleneffekte zu reduzieren. Durch die Kürzung würden gerade
              erwerbstätige Sozialhilfeempfänger ihren Anspruch auf Sozialhilfe
              verlieren. Die Differenz zwischen Familien in der Sozialhilfe und
              solchen, die knapp keinen Anspruch geltend machen können,
              vergrössert sich durch die SHG-Revision nicht. Ökonomen gehen
              zudem davon aus, dass bei einer Kürzung der Sozialhilfe auch die
              tiefen Löhne unter Druck kommen könnten.
            </p>
            <ul>
              <li>
                Mehr Informationen zu den Kosten liefert folgender Artikel:{' '}
                <a
                  href={
                    this.state.isMobile
                      ? 'https://m.derbund.ch/articles/5c954432ab5c371cff000001'
                      : 'https://www.derbund.ch/17949822'
                  }
                >
                  <i className='external icon' />
                  «Was sie über Sozialhilfe wissen müssen»
                </a>
                .
              </li>
              <li>
                Pascal Coullery, Dozent an der Berner Fachhochschule für Soziale
                Arbeit, glaubt, dass nach der Kürzung das verfassungsmässige
                Recht auf ein menschenwürdiges Leben nicht mehr garantiert
                werden kann. Mit seinem Gutachten befasst sich folgender
                Artikel:{' '}
                <a
                  href={
                    this.state.isMobile
                      ? 'https://m.derbund.ch/articles/5ccb3654ab5c374dc3000001'
                      : 'https://www.derbund.ch/22990633'
                  }
                >
                  <i className='external icon' />
                  «Schneggs Gegner drohen mit Bundesgericht»
                </a>
                .
              </li>
              <li>
                Mit Schwelleneffekten und Anreizsystem befasst sich folgender
                Artikel:{' '}
                <a
                  href={
                    this.state.isMobile
                      ? 'https://m.derbund.ch/articles/5cc0b9f5ab5c371e3d000001'
                      : 'https://www.derbund.ch/31523534'
                  }
                >
                  <i className='external icon' />
                  «Manchmal bezahlt der Sozialdienst besser als die Firma»
                </a>
                .
              </li>
              <li>
                Die Argumente von Politökonom Christoph Schaltegger, der die
                Revision befürwortet, erfahren Sie hier:{' '}
                <a
                  href={
                    this.state.isMobile
                      ? 'https://m.derbund.ch/articles/5cc0b60eab5c3734a3000001'
                      : 'https://www.derbund.ch/20223946'
                  }
                >
                  <i className='external icon' />
                  «Der hohe Grundbedarf hält Leute vom Arbeitsmarkt fern».
                </a>
              </li>
            </ul>
          </div>
          <div
            className='ui question container'
            id='question-6'
            style={{ textAlign: 'left' }}
          >
            <h2>
              <span className='title-text'>
                6. Was spricht für den Volksvorschlag, und was dagegen?
              </span>
              <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>{' '}
                  <i className='chevron up icon' />
                </div>
              </Scrollchor>
            </h2>
          </div>
          <div className='ui text container'>
            <p>
              Der Volksvorschlag verhindert einen Standortwettbewerb, in dem
              sich die Kantone gegenseitig mit Verschärfungen zu überbieten
              versuchen, in dem er die Sozialhilfe streng nach Skos-Richtlinien
              bemessen will. Er sorgt also dafür, dass der nationale Konsens
              zumindest vorderhand nicht infrage gestellt wird.
            </p>
            <p>
              Zudem nimmt sich der Volksvorschlag dem Umstand an, dass die
              Klientel der Sozialdienste meist schlechter ausgebildet ist, als
              vom Arbeitsmarkt gefordert. Dies in dem er
              Qualifizierungsmassnahmen explizit ins Gesetz schreibt.
            </p>
            <p>
              Schliesslich trägt er dem Umstand Rechnung, dass der soziale Fall
              bei über 55-Jährigen Langzeitarbeitslosen meist grösser ist, als
              bei Jüngeren. Die Leute, die in diesem Alter auf Sozialhilfe
              angewiesen sind, haben häufig lange gearbeitet und gewisse
              Reserven gebildet. Heute müssen sie das ganze Ersparte (bis auf
              4000 Franken) aufbrauchen, bis sie Unterstützung erhalten. Die
              über 55-Jährigen sind zudem die am stärksten wachsende Gruppe in
              der Sozialhilfe.
            </p>
            <p>
              Gegen den Volksvorschlag sprechen die Kosten. So führt die Vorlage
              zu Mehrkosten in der Höhe von 17-28 Millionen Franken - und das,
              obwohl die Sozialhilfekosten ohnehin steigen.
            </p>
            <p>
              Auch die geforderte Besserstellung der Ü-55-Jährigen führt zu
              Ungerechtigkeiten. Wer etwa selbstständig ist, bezahlt kein Geld
              in die Arbeitslosenkasse. Dies ist aber Bedingung, um von der
              Besserstellung profitieren zu dürfen. Zudem ist die Sozialhilfe
              ein Bedarfssystem, keine Versicherung. 60-Jährige haben aber
              keinen anderen Bedarf als 50-Jährige.
            </p>
            <p>
              Schliesslich wird argumentiert, dass die Besserstellung dazu
              führen könnte, dass Unternehmen ältere Leute schneller entlassen
              könnten. Und umgekehrt, dass sich die Bessergestellten weniger um
              Arbeit bemühen würden, weil sie dank Ergänzungsleistungen bereits
              ein angenehmes Leben führen könnten.
            </p>

            <p>
              Gab es nicht Uneinigkeiten betreffend den Kosten des
              Volksvorschlags? Doch. Folgende Artikel helfen weiter:
            </p>
            <ul>
              <li>
                <a
                  href={
                    this.state.isMobile
                      ? 'https://m.derbund.ch/articles/5c54157bab5c3772f4000001'
                      : 'https://www.derbund.ch/23779331'
                  }
                >
                  <i className='external icon' />
                  «Schnegg hat sich bei der Sozialhilfe verrechnet»
                </a>
              </li>
              <li>
                {' '}
                <a
                  href={
                    this.state.isMobile
                      ? 'https://m.derbund.ch/articles/5bf69577ab5c377b98000001'
                      : 'https://www.derbund.ch/23513273'
                  }
                >
                  <i className='external icon' />
                  «Regierungsrat Schnegg lenkt im Zahlenstreit ein»
                </a>
              </li>
              <li>
                {' '}
                <a
                  href={
                    this.state.isMobile
                      ? 'https://m.derbund.ch/articles/5bf597ddab5c37217e000001'
                      : 'https://www.derbund.ch/21207125'
                  }
                >
                  <i className='external icon' />
                  «Schnegg hat das nicht nötig»
                </a>
              </li>
              <li>
                {' '}
                <a
                  href={
                    this.state.isMobile
                      ? 'https://m.derbund.ch/articles/5bf58841ab5c372d21000001'
                      : 'https://www.derbund.ch/20499627'
                  }
                >
                  <i className='external icon' />
                  «Zweifel an Schneggs Rechenkünsten
                </a>
              </li>
            </ul>
          </div>
          <Waypoint
            scrollableAncestor={window}
            onEnter={(event) => {
              if (event.previousPosition === 'below') {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: '50ContentRead'
                })
              }
            }}
          />
          <div
            className='ui question container'
            id='question-7'
            style={{ textAlign: 'left' }}
          >
            <h2>
              <span className='title-text'>
                7. Wie positionieren sich die Parteien?
              </span>
              <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>{' '}
                  <i className='chevron up icon' />
                </div>
              </Scrollchor>
            </h2>
          </div>
          <div className='ui text container'>
            <h4>Die Parolen der Parteien</h4>
            <h5>Die meisten Parteien empfehlen nur eine Vorlage</h5>
            <table className='ui striped unstackable table'>
              <thead>
                <tr>
                  <th>Partei</th>
                  <th>Revision</th>
                  <th>Volksvorschlag</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>SVP</td>
                  <td>Ja</td>
                  <td>Nein</td>
                </tr>
                <tr>
                  <td>SP</td>
                  <td>Nein</td>
                  <td>Ja</td>
                </tr>
                <tr>
                  <td>FDP</td>
                  <td>Ja</td>
                  <td>Nein</td>
                </tr>
                <tr>
                  <td>Grüne</td>
                  <td>Nein</td>
                  <td>Ja</td>
                </tr>
                <tr>
                  <td>BDP</td>
                  <td>Ja</td>
                  <td>Nein</td>
                </tr>
                <tr>
                  <td>GLP</td>
                  <td>Nein</td>
                  <td>Nein</td>
                </tr>
                <tr>
                  <td>EVP</td>
                  <td>Nein</td>
                  <td>Stimmfreigabe</td>
                </tr>
                <tr>
                  <td>EDU</td>
                  <td>Ja</td>
                  <td>Nein</td>
                </tr>
                <tr>
                  <td>AL</td>
                  <td>Nein</td>
                  <td>Ja</td>
                </tr>
                <tr>
                  <td>CVP</td>
                  <td>Nein</td>
                  <td>Ja</td>
                </tr>
              </tbody>
            </table>
            <ul>
              <li>
                <a href='https://www.aenderung-sozialhilfegesetz.ch/'>
                  <i className='external icon' />
                  Hier geht es zur Website der Befürworter der SHG-Revision.
                </a>
              </li>
              <li>
                <a href='https://www.wirksame-sozialhilfe.ch/komitee/'>
                  <i className='external icon' />
                  Hier geht es zur Website des Komitees für den Volksvorschlag.
                </a>
              </li>
              <li>
                <a href='https://sozialhilfeabstimmung-be.ch/'>
                  <i className='external icon' />
                  Auf dieser Webseite argumentieren die Grünliberalen dafür,
                  beide Vorlagen abzulehnen.
                </a>
              </li>
            </ul>
          </div>

          <div
            className='ui question container'
            id='question-8'
            style={{ textAlign: 'left' }}
          >
            <h2>
              <span className='title-text'>
                8. Was ist die Meinung der «Bund»-Redaktion?
              </span>
              <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>{' '}
                  <i className='chevron up icon' />
                </div>
              </Scrollchor>
            </h2>
          </div>
          <div className='ui text container'>
            <p>Der «Bund» empfiehlt, beide Vorlagen abzulehnen.</p>
            <ul>
              <li>
                Folgender Artikel erklärt, wieso:{' '}
                <a
                  href={
                    this.state.isMobile
                      ? 'https://m.derbund.ch/articles/5ccc9d7eab5c3720aa000001'
                      : 'https://www.derbund.ch/26161498'
                  }
                >
                  <i className='external icon' />
                  Von dieser Kürzung sollten wir absehen
                </a>
              </li>
            </ul>
          </div>
          <Waypoint
            scrollableAncestor={window}
            onEnter={(event) => {
              if (event.previousPosition === 'below') {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: '80ContentRead'
                })
              }
            }}
          />
        </main>
        <Waypoint
          scrollableAncestor={window}
          onEnter={(event) => {
            if (event.previousPosition === 'below') {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'pageBottom'
              })
            }
          }}
        />
        <footer className='ui vertical segment'>
          <div className='ui container'>
            <div className='ui two column divided stackable inverted grid'>
              <div className='stretched aligned row'>
                <div className='column'>
                  <table className='ui definition very basic small inverted infographic table'>
                    <tbody>
                      <tr>
                        <td>Idee, Text, Programmierung</td>
                        <td>Fabian Christl und Christian Zellweger</td>
                      </tr>
                      <tr>
                        <td>Format</td>
                        <td>Marc Brupacher, Mathias Lutz</td>
                      </tr>
                      <tr>
                        <td>Grafik</td>
                        <td>Daniel Barben, Klaudia Meisterhans</td>
                      </tr>
                      <tr>
                        <td>Veröffentlicht</td>
                        <td>
                          <TimestampFormatter timestamp={1557028100} />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='column'>
                  <FeedbackMessage mailTo='bern@derbund.ch' />
                  <div className='ui fluid share center aligned container'>
                    <PolymorphicShareButtons articleId='16186604' />
                  </div>
                  <Tracking articleId='16186604' />
                </div>
                <div className='column'>
                  <div className='ui fluid copyright container'>
                    <CopyrightNotice />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    )
  }
}

AppComponent.defaultProps = {}



// WEBPACK FOOTER //
// ./src/components/main/index.js